(ns minorodata.components.connections.core
  (:require [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.connections.connections-list :as connections-list]
            [minorodata.components.connections.drawers :as connections-drawers]
            [minorodata.components.connections.overview :as connections-overview]
            [minorodata.components.connections.sources-and-extracts :as sources-and-extracts]
            [re-posh.core :as re-posh]
            [ui.page :refer [page-content page-controls page-header page-root
                             page-title]]
            [ui.tabs]))

(defn connections-tabs []
  [{:value   :connections
    :enabled true
    :data-cy "overview-tab"
    :label   "Overview"}
   {:value   :sources
    :enabled true
    :data-cy "sources-tab"
    :label   "Connect new source"}
   {:value   :extracts
    :enabled true
    :data-cy "extracts-tab"
    :label   "My sources and extracts"}])

(defn nav-tabs []
  (let [route-name @(re-posh/subscribe [:app-route/prop :app-route/name])
        route-name (case route-name
                     (:source-details :extract-details) :extracts
                     route-name)

        tabs       (->> (connections-tabs)
                        (filter :enabled))]
    [ui.tabs/tabs {:value           route-name
                   :on-value-change #(dispatch [:app.events/navigate (keyword %)])
                   :variant         :underlined
                   :tabs            tabs
                   :classes         {:list "border-b-transparent"}}]))

(defn page [{:keys [variant]} children]
  [:<>
   [page-root {}
    [page-header {:variant       variant
                  :style         {:top "-3.5rem"}
                  :content-props {:class "pb-0"}}
     [page-title "Connections"]
     [page-controls
      [nav-tabs]]]
    [page-content {:variant variant}
     children]]

   [:f> connections-drawers/drawers]])

(defn overview []
  [page {}
   [connections-overview/overview]])

(defn sources-list []
  [:<>
   [page-root
    [page-header {}
     [page-title "Add new source"]]
    [page-content {}
     [connections-list/connections-list]]]
   [:f> connections-drawers/drawers]])

(defn extracts-list [props]
  [:<>
   [page-root
    [page-content {:variant :border}
     [sources-and-extracts/sources-and-extracts props]]]
   [:f> connections-drawers/drawers]])
